import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuItemStore } from '~/services/api/contracts/requests/MenuItemStore'

// StoreMenuItemRequest: the partner route has no menuId segment, so menu_id is required.
export const MenuItemStoreForPartner = (_context: NoContext): ReturnType<typeof MenuItemStore> =>
  MenuItemStore({ menu_id_required: true })
